var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0.000976562H2C0.9 0.000976562 0 0.900977 0 2.00098V16.001C0 17.101 0.9 18.001 2 18.001H18C19.1 18.001 20 17.101 20 16.001V2.00098C20 0.900977 19.1 0.000976562 18 0.000976562ZM7 14.001H4C3.45 14.001 3 13.551 3 13.001C3 12.451 3.45 12.001 4 12.001H7C7.55 12.001 8 12.451 8 13.001C8 13.551 7.55 14.001 7 14.001ZM7 10.001H4C3.45 10.001 3 9.55098 3 9.00098C3 8.45098 3.45 8.00098 4 8.00098H7C7.55 8.00098 8 8.45098 8 9.00098C8 9.55098 7.55 10.001 7 10.001ZM7 6.00098H4C3.45 6.00098 3 5.55098 3 5.00098C3 4.45098 3.45 4.00098 4 4.00098H7C7.55 4.00098 8 4.45098 8 5.00098C8 5.55098 7.55 6.00098 7 6.00098ZM16.7 8.12098L13.53 11.291C13.14 11.681 12.5 11.681 12.11 11.291L10.7 9.87098C10.31 9.48098 10.31 8.85098 10.7 8.46098C11.09 8.07098 11.72 8.07098 12.11 8.46098L12.82 9.17098L15.29 6.70098C15.68 6.31098 16.31 6.31098 16.7 6.70098L16.71 6.71098C17.09 7.10098 17.09 7.74098 16.7 8.12098Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfileIcon);
export default __webpack_public_path__ + "static/media/my-profile-icon.06360eb263681173ad3e369e9fe3dfe4.svg";
export { ForwardRef as ReactComponent };